import { ReactNode } from 'react';
import { default as IconButton } from '@mui/material/IconButton';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { Popover, usePopover } from 'modules/minimal-ui-theme';

type Props = {
  children: ReactNode;
  icon: React.ComponentType<SvgIconProps>;
  ariaLabel: string;
};
export const DropdownMenu = ({ children, icon: Icon, ariaLabel }: Props) => {
  const { onOpen, open, anchorEl, onClose } = usePopover();

  return (
    <>
      <IconButton
        onClick={onOpen}
        aria-label={ariaLabel}
        sx={{
          p: 0
        }}
      >
        <Icon />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        sx={{ minWidth: 200, maxWidth: 300, p: 0 }}
      >
        {children}
      </Popover>
    </>
  );
};
